export type ORDER_TYPE = "BUY" | "SELL";
export type POST_TYPE = "BUY" | "SELL";
export enum POST_STATUS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  CANCELLED = "CANCELLED",
}
export enum ORDER_STATUS {
  OPEN = "OPEN",
  PAID = "PAID",
  CLOSED = "CLOSED",
  CANCELLED = "CANCELLED",
}
export enum PAYMENT_STATUS {
  ENABLE = "enabled",
  DISABLE = "disabled",
}

export enum VERIFICATION_STATUS {
  PENDING = "pending",
  COMPLETED = "completed",
  FAILED = "failed",
}
